document.addEventListener('DOMContentLoaded', () => {
  function updateArrowStates(swiper, prevBtn, nextBtn) {
      const isBeginning = swiper.isBeginning || swiper.activeIndex <= 0;
      const isEnd = swiper.isEnd;
      const isBothDisabled = swiper.isLocked || (isBeginning && isEnd);

      if (prevBtn) {
          if (isBothDisabled || isBeginning) {
              prevBtn.classList.add('slider-button--disabled');
          } else {
              prevBtn.classList.remove('slider-button--disabled');
          }
          if (isBothDisabled) {
              prevBtn.classList.add('slider-button--both-disabled');
          } else {
              prevBtn.classList.remove('slider-button--both-disabled');
          }
      }
      if (nextBtn) {
          if (isBothDisabled || isEnd) {
              nextBtn.classList.add('slider-button--disabled');
          } else {
              nextBtn.classList.remove('slider-button--disabled');
          }
          if (isBothDisabled) {
              nextBtn.classList.add('slider-button--both-disabled');
          } else {
              nextBtn.classList.remove('slider-button--both-disabled');
          }
      }
  }

  const featureProductContainers = document.querySelectorAll('.section-feature-product-list');
  featureProductContainers.forEach(function(container) {
      const productTabs = container.querySelectorAll('.feature-products-tab-wrapper');
      const tabHeadingsContainer = container.querySelector('.feature-product-tab__heading');
      container.classList.add('loaded');
      if(productTabs.length === 0) return;
      if(productTabs) {
          productTabs.forEach(function(tab, index) {
              const dataTab = tab.getAttribute('data-tab');
              const noProductInCollection = tab.querySelector('.no-product');
              // Hide tab if no products in collection
              if(noProductInCollection) {
                  tab.classList.add('inactive');
                  return;
              }
              if(dataTab) {
                  const tagSpan = document.createElement('span');
                  const hasProducts = tab.querySelectorAll(
                      '.feature-products__swiper .section-resource__collection'
                  ).length > 0;

                  if (!hasProducts) {
                      tab.classList.remove('active');
                      return;
                  }

                  tagSpan.innerHTML = dataTab;
                  tagSpan.setAttribute('class', 'tab__heading');
                  tagSpan.setAttribute('data-tab', dataTab);
                  if(index === 0) {
                      tagSpan.classList.add('active');
                      tab.classList.add('active');
                      tagSpan.addEventListener('click', function() {
                          // Remove active class from all tabs
                          const allHeadings = tabHeadingsContainer.querySelectorAll('.tab__heading');
                          allHeadings.forEach(function(heading) {
                              heading.classList.remove('active');
                          });
                          const allTabs = container.querySelectorAll('.feature-products-tab-wrapper');
                          allTabs.forEach(function(t) {
                              t.classList.remove('active');
                          });
                          // Add active class to clicked tab
                          tagSpan.classList.add('active');
                          tab.classList.add('active');
                      });
                  }
                  tabHeadingsContainer?.appendChild(tagSpan);
              }
          });
          const tabHeadings = tabHeadingsContainer.querySelectorAll('.tab__heading');
          if(!tabHeadings.length) {
              tabHeadingsContainer?.classList.add('hidden');
          }
          tabHeadings.forEach(function(heading) {
              heading.addEventListener('click', function() {
                  const tabValue = heading.getAttribute('data-tab');
                  // Remove active class from all tabs
                  const allHeadings = tabHeadingsContainer.querySelectorAll('.tab__heading');
                  allHeadings.forEach(function(h) {
                      h.classList.remove('active');
                  });
                  const allTabs = container.querySelectorAll('.feature-products-tab-wrapper');
                  allTabs.forEach(function(t) {
                      t.classList.remove('active');
                      t.classList.add('inactive');
                  });
                  // Add active class to clicked tab
                  heading.classList.add('active');

                  const activeTab = container.querySelector(`.feature-products-tab-wrapper[data-tab="${tabValue}"]`);
                  if(activeTab) {
                      const isRecentlyViewed = activeTab.querySelector('.collection-selector-wrapper.recently_viewed_products');

                      activeTab.classList.add('active');
                      activeTab.classList.remove('inactive');

                      if(isRecentlyViewed) {
                          // Trigger event to load recently viewed products
                          const event = new Event('amLoadRecentlyViewedProducts');
                          window.dispatchEvent(event);
                      }
                  }
              });
          });
      }
      if (tabHeadingsContainer) {
          let isDown = false;
          let startX;
          let scrollLeft;

          tabHeadingsContainer.addEventListener('mousedown', (e) => {
              isDown = true;
              tabHeadingsContainer.classList.add('dragging');
              startX = e.pageX - tabHeadingsContainer.offsetLeft;
              scrollLeft = tabHeadingsContainer.scrollLeft;
          });

          tabHeadingsContainer.addEventListener('mouseleave', () => {
              isDown = false;
              tabHeadingsContainer.classList.remove('dragging');
          });

          tabHeadingsContainer.addEventListener('mouseup', () => {
              isDown = false;
              tabHeadingsContainer.classList.remove('dragging');
          });

          tabHeadingsContainer.addEventListener('mousemove', (e) => {
              if (!isDown) return;
              e.preventDefault();
              const x = e.pageX - tabHeadingsContainer.offsetLeft;
              const walk = (x - startX) * 1; // Adjust scroll speed if needed
              tabHeadingsContainer.scrollLeft = scrollLeft - walk;
          });
      }
  });

  const swiperSliders = document.querySelectorAll('.swiper.product-slider:not(.recently_viewed_products)');
  if(swiperSliders) {
      swiperSliders.forEach(function(swiperEl) {
          const nextEl = swiperEl.querySelector('.swiper-button-next');
          const prevEl = swiperEl.querySelector('.swiper-button-prev');
          const sliderContainer = new Swiper(swiperEl, {
            loop: false,
            simulateTouch: true,
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            spaceBetween: 16,
            centeredSlidesBounds: true,

            watchSlidesProgress: true,
            watchSlidesVisibility: true,
              breakpoints: {
                750: {
                  slidesPerView: 3.3,
                  slidesPerGroup: 3,
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 4.3,
                  slidesPerGroup: 4,
                  spaceBetween: 16
                }
              },
              navigation: {
                  nextEl: nextEl,
                  prevEl: prevEl
              }
          });
          }
      );
  }

  // Replace Boost AI Slick carousels with Swiper
  function replaceBoostSlickWithSwiper(slider) {
      if (slider.dataset.swiperInitialized) return;

      var sliderContainer = slider.querySelector('.boost-sd__swiper-container');
      if (!sliderContainer) return;

      var prevBtnInner = slider.querySelector('.boost-sd__prev-button .boost-sd__swiper-button');
      var nextBtnInner = slider.querySelector('.boost-sd__next-button .boost-sd__swiper-button');
      var prevBtn = slider.querySelector('.boost-sd__prev-button');
      var nextBtn = slider.querySelector('.boost-sd__next-button');

      try {
          if (sliderContainer.slick && typeof sliderContainer.slick.unslick === 'function') {
              sliderContainer.slick.unslick();
          }
      } catch (e) { /* slick not available */ }

      sliderContainer.querySelectorAll('.slick-cloned').forEach(function(el) { el.remove(); });

      var slickTrack = sliderContainer.querySelector('.slick-track');
      if (slickTrack) {
          var originalSlides = slickTrack.querySelectorAll('.boost-sd__slide');
          originalSlides.forEach(function(slide) { sliderContainer.appendChild(slide); });
          var slickList = sliderContainer.querySelector('.slick-list');
          if (slickList) slickList.remove();
      }

      sliderContainer.className = sliderContainer.className.replace(/slick-[\w-]+/g, '').trim();
      sliderContainer.removeAttribute('role');
      sliderContainer.style.cssText = '';
      slider.querySelectorAll('.slick-dots').forEach(function(el) { el.remove(); });

      var slides = sliderContainer.querySelectorAll('.boost-sd__slide');
      slides.forEach(function(slide) {
          slide.className = slide.className.replace(/slick-[\w-]+/g, '').trim();
          slide.removeAttribute('data-slick-index');
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
          slide.style.width = '';
      });

      if (slides.length === 0) return;

      slider.classList.add('swiper');
      sliderContainer.classList.add('swiper-wrapper');
      slides.forEach(function(slide) { slide.classList.add('swiper-slide'); });

      if (prevBtnInner) prevBtnInner.removeAttribute('disabled');
      if (nextBtnInner) nextBtnInner.removeAttribute('disabled');

      // Move promo-block-item inside swiper-wrapper as first slide
      var tabWrapper = slider.closest('.feature-products-tab-wrapper');
      if (tabWrapper) {
          var promoBlock = tabWrapper.querySelector('.promo-block-item');
          if (promoBlock) {
              promoBlock.classList.add('swiper-slide');
              sliderContainer.insertBefore(promoBlock, sliderContainer.firstChild);
          }
      }

      // Check if this carousel is inside feature-banner-products
      var isFeatureBanner = !!slider.closest('.feature-banner-products-wrapper');

      // Initialize Swiper
      const featureBannerSwiper = new Swiper(slider, {
        loop: false,
        simulateTouch: true,
        slidesPerView: isFeatureBanner ? 1.2 : 1.4,
        slidesPerGroup: 1,
        spaceBetween: 24,
        centeredSlidesBounds: true,

        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        breakpoints: {
          750: {
            slidesPerView: isFeatureBanner ? 2 : 3.3,
            slidesPerGroup: isFeatureBanner ? 1 : 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: isFeatureBanner ? 2 : 3.3,
            slidesPerGroup: isFeatureBanner ? 1 : 3,
            spaceBetween: 24,
          },
          1440: {
            slidesPerView: isFeatureBanner ? 3 : 4.3,
            slidesPerGroup: isFeatureBanner ? 1 : 4,
            spaceBetween: 24
          }
        },
        navigation: {
          nextEl: nextBtnInner,
          prevEl: prevBtnInner,
        },

        on: {
          init: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          },
          slideChange: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          },
          reachEnd: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          },
          reachBeginning: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          },
          resize: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          },
          observerUpdate: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          },
          lock: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          },
          unlock: function () {
            updateArrowStates(this, prevBtn, nextBtn);
          }
        }
      });

      if (isFeatureBanner) {
          featureBannerSwiper.params.slidesPerGroup = 1;
      }

      // Boost may keep its original click handler after Slick is replaced.
      // Guard the Next & Prev buttons so they advance cleanly.
      if (isFeatureBanner && nextBtnInner) {
          nextBtnInner.addEventListener('click', function(event) {
              event.preventDefault();
              event.stopImmediatePropagation();
              if (!featureBannerSwiper.isEnd) {
                  featureBannerSwiper.slideNext();
              }
              updateArrowStates(featureBannerSwiper, prevBtn, nextBtn);
          }, true);
      }
      if (isFeatureBanner && prevBtnInner) {
          prevBtnInner.addEventListener('click', function(event) {
              event.preventDefault();
              event.stopImmediatePropagation();
              if (!featureBannerSwiper.isBeginning) {
                  featureBannerSwiper.slidePrev();
              }
              updateArrowStates(featureBannerSwiper, prevBtn, nextBtn);
          }, true);
      }

      slider.dataset.swiperInitialized = 'true';
  }

  // Observe DOM for Boost sliders that get Slick initialized
  var boostPendingSliders = new Set();
  var boostObserver = new MutationObserver(function() {
      var sliders = document.querySelectorAll('.boost-sd__swiper:not([data-swiper-initialized])');
      sliders.forEach(function(slider) {
          var container = slider.querySelector('.boost-sd__swiper-container');
          if (container && !boostPendingSliders.has(slider)) {
              boostPendingSliders.add(slider);
              setTimeout(function() {
                  replaceBoostSlickWithSwiper(slider);
                  boostPendingSliders.delete(slider);
              }, 50);
        }
      });

      });

  boostObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})
